/* eslint-disable react-hooks/exhaustive-deps */
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Grid from "@mui/material/Grid";
import { appConstants } from "utils/appConstants";
import React, { useEffect, useState } from "react";
import TimelineItem from "components/Icon/TimelineItem";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useMaterialUIController } from "context";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import MDButton from "components/MDButton";
import PageTitle from "examples/PageTitle/PageTitle";
import "react-toastify/dist/ReactToastify.css";
import DataTable, { createTheme } from "react-data-table-component";
import { useDispatch } from "react-redux";
import { getRCTIByID } from "utils/invoiceAPI";
import ActivityLog from "layouts/activityLog/activityLog";
const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "90%x",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

createTheme(
  "solarized",
  {
    text: {
      primary: "white",
      secondary: "white",
    },
    background: {
      default: "#202940",
    },
    context: {
      background: "#202940",
      text: "white",
    },
    divider: {
      default: "white",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);
createTheme(
  "light",
  {
    text: {
      primary: "black",
      secondary: "black",
    },
    background: {
      default: "white",
    },
    context: {
      background: "white",
      text: "black",
    },
    divider: {
      default: "gray",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);



function ViewInvoices() {
  const navigate = useNavigate();
  //Starts here change the pagination text Rows per page to Record per page
  let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
  if (changePaginationText !== undefined) {
    changePaginationText.getElementsByTagName("span")[0].textContent = "Records Per Page";
  }  //ends here change the pagination text Rows per page to Record per page
  const dispatch = useDispatch();
  const { id: InvoiceID } = useParams();
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [itemRowValues, setItemRowValues] = useState([
    {
      itemName: "", itemPrice: "", itemQuantity: "", gst: "", categoryCodeName: "", priceValidity: "None",
      priceValidityValue: "", discountType: "None", discountValue: "", discountAmount: ""
    },
  ]);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');
  const [values, setValues] = useState({
    rctiID: undefined,
    rctiNumber: 'Auto Generated',
    invoiceNumber: '',
    supplierID: '',
    purchaseOrderNumber: '',
    rctiDate: "",
    validUpto: "Same Day",
    dueDate: "",
    rctiStatus: 'Unpaid',
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    finalAmount: 0,
    paymentInstruction: '',
  })
  const [quoDocuments, setDocuments] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      await FetchRCTIDetails();
    };
    fetchData();
  }, []);

  const FetchRCTIDetails = async () => {
    getRCTIByID({ rctiID: InvoiceID }, (data) => {
      if (data.Result_Status) {
        data.Result_Output.length > 0 && setValues(data.Result_Output[0]);
        data.Result_Output[0].itemsList.length > 0 && setItemRowValues(data.Result_Output[0].itemsList);
        data.Result_Output[0].documentsList.length > 0 && setDocuments(data.Result_Output[0].documentsList);
      } else {
        setValues(data.Result_Output[0])
        console.log("Error in fetchPendinginvoiceForCustomer: ", data.Result_Message);
      }
    }, dispatch);

  }

  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
        minHeight: '30px'
      },
    },
    headCells: {
      style: {
        paddingLeft: "5px",
        paddingRight: "5px",
        fontSize: "12px",
        color: "white",
      },
    },
  };
  let columns = [
    {
      name: "Item Name",
      selector: row => row.itemName,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Description",
      selector: row => row.itemDescription,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px", textAlign: "center" },
    },
    {
      name: "Qty",
      selector: row => row.itemQuantity,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Item Price",
      selector: row => row.itemPrice,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Account",
      selector: row => row.categoryCodeName,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px", textAlign: "center" },
    },
    {
      name: "GST(%)",
      selector: row => row.gst,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    // {
    //   name: "Discount Type",
    //   selector: row => row.discountType,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },
    // {
    //   name: "Discount Value",
    //   selector: row => row.discountValue,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },

  ];

  const handleViewDocument = (selectedDocRow) => {
    setSetDocumentFileURL(appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName);
    setViewDocumentInModal(true);
  };


  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action",
      selector: (row) => row,
      center: true,
      cell: (row) => (
        <>
          <Grid item mt={-3}>
            <TimelineItem
              color="info"
              icon="visibility"
              onClick={() => { handleViewDocument(row) }}
              title="View"
            />
          </Grid>


        </>
      ),
    },
  ];




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary" sx={{ pb: "10px" }}>

          <PageTitle screenName="View RCTI" />
          <Grid container px={2} mt={2} spacing={2}>
            {/* invoice Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="RCTI Number"
                variant="outlined"
                disabled
                fullWidth
                value={values.rctiNumber}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            {/* contact Name Dropdown */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Supplier"
                variant="outlined"
                disabled
                fullWidth
                value={values.supplierName}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Reference Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Reference Number "
                variant="outlined"
                placeholder="Optional"
                fullWidth
                value={values.purchaseOrderNumber}
                inputProps={{
                  className: "custom-fieldtext",
                  maxLength: 50
                }}
                InputLabelProps={{ shrink: true }}

                disabled
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Date"
                variant="outlined"
                fullWidth
                value={values.rctiDate}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            {/* validUpto */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Due Upto"
                variant="outlined"
                fullWidth
                value={values.validUpto}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Due Date"
                variant="outlined"
                fullWidth
                value={values.dueDate}
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  disabled
                  label="Status"
                  value={values.rctiStatus}

                >
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>

          </Grid>
          <CardContent>
            <DataTable
              theme={darkMode ? "solarized" : "light"}
              columns={columns}
              data={itemRowValues}
              customStyles={customStyles}
              fixedHeaderScrollHeight="210px"
              fixedHeader={true}

            />
          </CardContent>
          <Grid container px={2} pt={2} pb={2} spacing={2}>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">GST Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  label="GST Type"
                  value={values.gstType || 'Inclusive'}
                  disabled
                >
                  <MenuItem value="Inclusive">Inclusive</MenuItem>
                  <MenuItem value="Exclusive">Exclusive</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label="Total Amount($)"
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.totalAmount}


              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label="Total Discount Amount($)"
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={parseFloat(values.totalDiscountAmount).toFixed(2)}

              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label="Final Amount($)"
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext"
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={parseFloat(values.finalAmount).toFixed(2)}

              />
            </Grid>

            <Grid item lg={12} xs={12}>
              <TextField
                type="text"
                label="Payment Instructions"
                variant="outlined"
                fullWidth
                value={values.paymentInstruction}
                disabled

              />
            </Grid>


          </Grid>
          {/* Doc Table only visible if doc Array have data */}
          {quoDocuments.length > 0 &&
            <CardContent>
              <DataTable
                theme={darkMode ? "solarized" : "light"}
                columns={documentColumns}
                data={quoDocuments}
                fixedHeaderScrollHeight="210px"
                fixedHeader={true}
                customStyles={customStyles}
              />
            </CardContent>
          }
          {values.rctiStatus === "Paid" && <>
            <Grid item px={2} pt={1} xs={12} md={4} lg={12} mt={2} >
              <p style={{ fontSize: "14px", fontWeight: "bold", color: "#008000" }} >RCTI Payment Details</p>
            </Grid>
            <Grid container px={2} mt={2} spacing={2} mb={2}>
              <Grid item lg={3} xs={6}>
                <TextField
                  type="text"
                  label="Payment Date"
                  variant="outlined"
                  placeholder="Optional"
                  fullWidth
                  disabled
                  InputLabelProps={{ shrink: true }}
                  value={values.paymentDate}
                />
              </Grid>
              <Grid item lg={3} xs={6}>
                <TextField
                  type="text"
                  label="Payment Mode"
                  variant="outlined"
                  placeholder="Payment Mode"
                  fullWidth
                  disabled
                  InputLabelProps={{ shrink: true }}
                  value={values.paymentMode}

                />
              </Grid>
              <Grid item lg={3} xs={6}>
                <TextField
                  type="text"
                  label="Transaction ID"
                  variant="outlined"
                  placeholder="Transaction ID"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  disabled
                  value={values.paymentTransactionID}

                />
              </Grid>
              <Grid item lg={3} xs={6}>
                <TextField
                  type="text"
                  label={`Payment Amount (${values.currencyValue})`}
                  variant="outlined"
                  placeholder={`Payment Amount (${values.currencyValue})`}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  disabled
                  value={`${parseFloat(values.paymentAmount).toFixed(2)}`}
                />
              </Grid>
            </Grid>
          </>}

          <Stack spacing={2} mt={2} pb={3} direction="row" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
            <Button variant="outlined" size="small" style={{ fontSize: "0.75rem", display: 'flex', alignItems: 'center', border: "1px solid #1ed6c9", color: '#1ed6c9', borderRadius: "5px", }} onClick={() => { navigate('/rcti') }}>
              Close
            </Button>
          </Stack>

        </Card>

      </div>

      <div >
        <Card style={{ marginTop: "20px" }}>
          <ActivityLog name="RCTI" />
        </Card>
      </div>
      <Modal
        open={viewDocumentInModal}
        onClose={() => setViewDocumentInModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          '& .MuiModal-root': {
            width: '100%',
            height: '100%',
          },
        }}
      >
        <Card sx={pdfStyle}>
          <Box>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Invoice Document Viewer
            </Typography>
            <iframe title="Invoice Document Viewer" src={getDocumentFileURL} width="100%" height="650" frameborder="0" allowfullscreen={true}></iframe>

            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton color="warning" className="modalButton" onClick={() => { setViewDocumentInModal(false) }}>

                Close
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>

    </DashboardLayout>
  );
}

export default ViewInvoices;
